<mat-drawer-container>
    <div class="content">
        <mat-card appearance="outlined" class="ingest-card">
            <mat-card-header>
                <mat-icon class="card-header-icon" mat-card-avatar>drive_folder_upload</mat-icon>
                <mat-card-title>Ingest File Management</mat-card-title>
                <mat-card-subtitle>Upload data files and manage the ingest folder</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
                <div class="ingest-columns">
                    <div class="ingest-column-left">
                        <app-ingest-file-tree></app-ingest-file-tree>
                    </div>
                    <div class="ingest-column-right">
                        <app-ingest-file-upload (uploaded)="onIngestFilesUploaded()"></app-ingest-file-upload>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</mat-drawer-container>
